/* NO DECORUM — signature layer. Pairs with assets/nd-plus.css.
   Caution-tape ticker that reacts to your scrolling, fate dice that pick
   a product for you, footer letters that misbehave, tilting product cards,
   a rubber stamp when something lands in the bag, shuffle on collections,
   and a tab title that misses you. Every piece is optional decoration. */
(function () {
  'use strict';

  var win = window;
  var doc = document;
  var root = doc.documentElement;
  var MOTION = function () { return root.classList.contains('nd-motion'); };
  var FINE = !!(win.matchMedia && win.matchMedia('(hover: hover) and (pointer: fine)').matches);

  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function rootUrl() { return (win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || '/'; }

  /* ---------------- 1. Caution-tape ticker ---------------- */
  var tapes = [];
  var tickRaf = 0;
  var lastT = 0;
  var lastY = win.scrollY || 0;
  var boost = 0;
  var scrollDir = 1;

  function tick(t) {
    tickRaf = 0;
    var dt = lastT ? Math.min((t - lastT) / 1000, 0.05) : 0.016;
    lastT = t;
    var y = win.scrollY || 0;
    var dy = y - lastY;
    lastY = y;
    if (dy) scrollDir = dy < 0 ? -1 : 1;
    boost = clamp(boost * 0.9 + Math.abs(dy) * 0.9, 0, 900);
    var any = false;
    tapes.forEach(function (tp) {
      if (!tp.vis || !tp.w) return;
      any = true;
      var v = (tp.speed + boost) * tp.dir * scrollDir;
      tp.x -= v * dt;
      if (tp.x <= -tp.w) tp.x += tp.w;
      if (tp.x > 0) tp.x -= tp.w;
      tp.track.style.transform = 'translate3d(' + tp.x.toFixed(2) + 'px,0,0)';
    });
    if (any) tickRaf = requestAnimationFrame(tick);
    else lastT = 0;
  }
  function startTick() { if (!tickRaf) tickRaf = requestAnimationFrame(tick); }

  function ticker(ctx) {
    qsa('[data-nd-ticker]', ctx).forEach(function (tape) {
      if (tape.__tk) return;
      tape.__tk = 1;
      var track = tape.querySelector('.nd-ticker__track');
      var group = track && track.querySelector('.nd-ticker__group');
      if (!group) return;
      var tp = {
        track: track,
        w: 0,
        x: 0,
        vis: false,
        speed: Number(tape.getAttribute('data-speed')) || 60,
        dir: Number(tape.getAttribute('data-dir')) || 1
      };
      function fill() {
        tp.w = group.getBoundingClientRect().width;
        if (!tp.w) return;
        var need = tape.clientWidth + tp.w * 2;
        var guard = 0;
        while (track.scrollWidth < need && guard++ < 30) {
          var copy = group.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          track.appendChild(copy);
        }
      }
      fill();
      win.addEventListener('resize', fill);
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(fill);
      if (!MOTION()) return;
      tapes.push(tp);
      if ('IntersectionObserver' in win) {
        new IntersectionObserver(function (en) {
          tp.vis = en[0].isIntersecting;
          if (tp.vis) startTick();
        }, { rootMargin: '120px 0px' }).observe(tape);
      } else { tp.vis = true; startTick(); }
    });
  }
  win.addEventListener('scroll', function () { if (tapes.length) startTick(); }, { passive: true });

  /* ---------------- 2. Let fate decide ---------------- */
  var fateCache = null;
  function products() {
    if (fateCache) return Promise.resolve(fateCache);
    return fetch(rootUrl() + 'products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('no'); return r.json(); })
      .then(function (d) {
        var list = (d && d.products) || [];
        var live = list.filter(function (p) { return (p.variants || []).some(function (v) { return v.available !== false; }); });
        fateCache = live.length ? live : list;
        return fateCache;
      });
  }
  function fate(ctx) {
    qsa('[data-nd-fate]', ctx).forEach(function (a) {
      if (a.__fate) return;
      a.__fate = 1;
      a.addEventListener('click', function (e) {
        if (!win.fetch || !win.Promise) return;
        e.preventDefault();
        var fallback = a.getAttribute('href');
        var box = doc.createElement('div');
        box.className = 'nd-fate';
        box.setAttribute('role', 'status');
        var die = '<svg class="nd-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="16" height="16" rx="3"/><path d="M8.5 8.5h.01M15.5 15.5h.01M12 12h.01M15.5 8.5h.01M8.5 15.5h.01"/></svg>';
        box.innerHTML = '<div class="nd-fate__dice" aria-hidden="true">' + die + die + '</div>';
        var msg = doc.createElement('p');
        msg.className = 'nd-fate__text';
        msg.textContent = a.getAttribute('data-rolling') || 'Rolling…';
        box.appendChild(msg);
        doc.body.appendChild(box);
        var started = Date.now();
        var minWait = MOTION() ? 1100 : 0;
        products().then(function (list) {
          if (!list.length) throw new Error('empty');
          var pick = list[Math.floor(Math.random() * list.length)];
          var wait = Math.max(0, minWait - (Date.now() - started));
          setTimeout(function () {
            box.classList.add('is-landed');
            var name = doc.createElement('p');
            name.className = 'nd-fate__pick';
            name.textContent = pick.title;
            box.appendChild(name);
            setTimeout(function () { win.location.href = rootUrl() + 'products/' + pick.handle; }, MOTION() ? 650 : 0);
          }, wait);
        }).catch(function () { win.location.href = fallback; });
      });
    });
  }

  /* ---------------- 3. Footer letters misbehave ---------------- */
  function letters() {
    var host = doc.querySelector('.nd-giant-host');
    if (!host || host.__lt) return;
    var g = host.querySelector('.nd-giant');
    if (!g) return;
    host.__lt = 1;
    var spans = qsa('.nd-giant__l > span', g);
    if (FINE && MOTION()) {
      host.addEventListener('pointermove', function (e) {
        spans.forEach(function (s) {
          var r = s.getBoundingClientRect();
          var cx = r.left + r.width / 2;
          var d = Math.abs(e.clientX - cx);
          var reach = r.width * 1.6;
          var k = clamp(1 - d / reach, 0, 1);
          var side = e.clientX < cx ? 1 : -1;
          s.style.setProperty('--ly', (-k * 22).toFixed(1) + '%');
          s.style.setProperty('--lr', (k * 9 * side).toFixed(1) + 'deg');
        });
      });
      host.addEventListener('pointerleave', function () {
        spans.forEach(function (s) { s.style.removeProperty('--ly'); s.style.removeProperty('--lr'); });
      });
    }
    host.addEventListener('click', function () {
      if (!MOTION()) return;
      g.classList.remove('is-jiggle');
      void g.offsetWidth;
      g.classList.add('is-jiggle');
      setTimeout(function () { g.classList.remove('is-jiggle'); }, 1400);
    });
  }

  /* ---------------- 4. Product cards tilt ---------------- */
  function tilt(ctx) {
    if (!FINE) return;
    qsa('.nd-card', ctx).forEach(function (card) {
      if (card.__tilt) return;
      card.__tilt = 1;
      var media = card.querySelector('.nd-card__media');
      if (!media) return;
      media.addEventListener('pointermove', function (e) {
        if (!MOTION()) return;
        var r = media.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        card.classList.add('is-tilt');
        media.style.setProperty('--ry', ((px - 0.5) * 9).toFixed(2) + 'deg');
        media.style.setProperty('--rx', ((0.5 - py) * 7).toFixed(2) + 'deg');
        media.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
        media.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
      });
      media.addEventListener('pointerleave', function () {
        card.classList.remove('is-tilt');
        media.style.removeProperty('--rx');
        media.style.removeProperty('--ry');
      });
    });
  }

  /* ---------------- 5. A stamp when something lands in the bag ---------------- */
  function stamps(ctx) {
    qsa('[data-nd-pdp]', ctx).forEach(function (sec) {
      if (sec.__stamp) return;
      sec.__stamp = 1;
      var add = sec.querySelector('[data-add]');
      var stage = sec.querySelector('.nd-pdp__stage');
      if (!add || !stage || !('MutationObserver' in win)) return;
      new MutationObserver(function () {
        if (!add.classList.contains('is-done') || !MOTION()) return;
        var old = stage.querySelector('.nd-stamp');
        if (old) old.remove();
        var st = doc.createElement('span');
        st.className = 'nd-stamp';
        st.setAttribute('aria-hidden', 'true');
        st.textContent = sec.getAttribute('data-l-stamp') || 'Approved';
        stage.appendChild(st);
        stage.classList.remove('is-thud');
        setTimeout(function () { stage.classList.add('is-thud'); }, 280);
        setTimeout(function () { st.remove(); stage.classList.remove('is-thud'); }, 2200);
      }).observe(add, { attributes: true, attributeFilter: ['class'] });
    });
  }

  /* ---------------- 6. Shuffle the grid ---------------- */
  function shuffle(ctx) {
    qsa('[data-nd-shuffle]', ctx).forEach(function (btn) {
      if (btn.__sh) return;
      btn.__sh = 1;
      btn.addEventListener('click', function () {
        var sec = btn.closest('[data-nd-coll]');
        var grid = sec && sec.querySelector('[data-nd-grid]');
        if (!grid) return;
        var kids = Array.prototype.slice.call(grid.children);
        var first = kids.map(function (k) { return k.getBoundingClientRect(); });
        var order = kids.map(function (k, i) { return i; });
        for (var i = order.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var t = order[i]; order[i] = order[j]; order[j] = t;
        }
        order.forEach(function (i) { grid.appendChild(kids[i]); });
        btn.classList.add('is-busy');
        setTimeout(function () { btn.classList.remove('is-busy'); }, 700);
        if (!MOTION() || !('animate' in Element.prototype)) return;
        kids.forEach(function (k, i) {
          var last = k.getBoundingClientRect();
          var dx = first[i].left - last.left;
          var dy = first[i].top - last.top;
          if (!dx && !dy) return;
          k.animate(
            [{ transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(' + (Math.random() * 6 - 3).toFixed(1) + 'deg)' }, { transform: 'none' }],
            { duration: 650 + Math.random() * 250, easing: 'cubic-bezier(.34,1.3,.64,1)' }
          );
        });
      });
    });
  }

  /* ---------------- 7. The tab misses you ---------------- */
  function awayTitle() {
    var src = doc.querySelector('[data-nd-away]');
    var text = src && src.getAttribute('data-nd-away');
    if (!text || win.__ndAway) return;
    win.__ndAway = 1;
    var original = doc.title;
    doc.addEventListener('visibilitychange', function () {
      if (doc.hidden) { original = doc.title; doc.title = text; }
      else doc.title = original;
    });
  }

  /* ---------------- 8. Cursor press ---------------- */
  doc.addEventListener('pointerdown', function () { var c = doc.querySelector('.nd-cursor'); if (c) c.classList.add('is-down'); });
  doc.addEventListener('pointerup', function () { var c = doc.querySelector('.nd-cursor'); if (c) c.classList.remove('is-down'); });

  /* ---------------- Start ---------------- */
  function setup(ctx) {
    ticker(ctx);
    fate(ctx);
    tilt(ctx);
    stamps(ctx);
    shuffle(ctx);
    awayTitle();
    /* the footer wordmark is drawn by nd-motion.js; wait a beat for it */
    setTimeout(letters, 60);
  }
  function start() { try { setup(doc); } catch (e) { if (win.console) console.warn('[nd+]', e); } }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
  else start();
  win.addEventListener('load', function () { try { letters(); } catch (e) {} });

  /* cards added later (load-more, recommendations) */
  if ('MutationObserver' in win) {
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.nodeType === 1 && (n.matches('.nd-card') || n.querySelector('.nd-card'))) tilt(n.parentNode || n);
        });
      });
    }).observe(doc.documentElement, { childList: true, subtree: true });
  }

  doc.addEventListener('shopify:section:load', function (e) { try { setup(e.target); } catch (err) {} });

  if (win.console && console.log) {
    console.log('%cNO DECORUM.', 'font: 900 28px Georgia, serif; letter-spacing: -1px;');
    console.log('Reading the source code of a T-shirt shop. Bold. We respect it.');
  }
})();
